import type {CollarsAfterStateRow, CollarsPreviewLeg} from './collars-after-state-rows';
import type {OrderPreviewLeg, OrderPreviewTables} from '../../order-preview/order-preview-tables.component';

/** Preserve independent diff arrays and transaction emission order (not display sorting). */
export function manualPreviewTables(row: CollarsAfterStateRow): OrderPreviewTables {
    const position = (leg: CollarsPreviewLeg): OrderPreviewLeg => ({
        kind: leg.kind, ticker: leg.ticker, qty: leg.side * leg.qty,
        type: leg.type, expiration: leg.expiration, strike: leg.strike
    });
    return {
        before: row.before.map(position),
        transaction: row.transaction.map(l => ({...position(l), action: l.operation, fillPx: null, marketPx: null})),
        after: row.after.map(position)
    };
}

export function manualPricingHint(tables: OrderPreviewTables): string {
    const total = tables.transaction.length;
    const priced = tables.transaction.filter(l => typeof l.fillPx === 'number' && isFinite(l.fillPx) && l.fillPx > 0).length;
    return priced > 0 && priced < total
        ? `${priced} of ${total} legs priced — price every leg before completing the transaction` : '';
}
